import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main-menu-modal-icon"
}
const _hoisted_2 = { class: "menu-items-wrapper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "menu-item-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, {
      translucent: "",
      class: "main-menu-toolbar"
    }, {
      default: _withCtx(() => [
        (_ctx.menuIcon)
          ? (_openBlock(), _createBlock(_component_ion_icon, {
              key: 0,
              class: "menu-icon",
              icon: _ctx.menuIcon
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        (_ctx.menuTitle)
          ? (_openBlock(), _createBlock(_component_ion_text, {
              key: 1,
              class: "menu-title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.menuTitle), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_toolbar, {
          class: "modal-toolbar",
          mode: "md"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, { onClick: _ctx.dismiss }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("messages.application.close")) + " ", 1),
                    _createVNode(_component_ion_icon, {
                      src: _ctx.close,
                      style: {"font-size":"20px"}
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "menu-modal-wrapper" }, {
      default: _withCtx(() => [
        (_ctx.menuClass === 'main-menu-modal')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_ion_icon, { icon: _ctx.menu }, null, 8, ["icon"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "menu-item",
              key: item.name
            }, [
              _createElementVNode("div", {
                class: "sub-menu-chiplet",
                onClick: item.handler
              }, [
                _createVNode(_component_ion_icon, {
                  class: "chiplet-icon",
                  icon: item.icon,
                  mode: "md"
                }, null, 8, ["icon"])
              ], 8, _hoisted_3),
              (item.label)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.label), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ], 64))
}